import React, { useEffect, useState } from "react";
import { Modal, Tabs, Transfer, message, Typography, Row, Col } from "antd";
import { DatabaseOutlined, CloudOutlined } from "@ant-design/icons";
import useUserResources from "../hooks/useUserResources";

const { TabPane } = Tabs;
const { Title } = Typography;

export default function AssignResourcesModal({ open, onClose, user, initialTab }) {
  const [devices, setDevices] = useState([]);
  const [deviceTargetKeys, setDeviceTargetKeys] = useState([]);
  const [emissionPoints, setEmissionPoints] = useState([]);
  const [emissionTargetKeys, setEmissionTargetKeys] = useState([]);

  const { loadAllResources, saveAssignments } = useUserResources(user?.username);

  useEffect(() => {
    if (open && user?.username) {
      loadAllResources()
        .then(data => {
          setDevices(data.devices);
          setDeviceTargetKeys(data.deviceTargetKeys);
          setEmissionPoints(data.emissionPoints);
          setEmissionTargetKeys(data.emissionTargetKeys);
        })
        .catch(() => message.error("Failed to load resources"));
    }
  }, [open, user]);

  const handleSave = async () => {
    try {
      await saveAssignments(
        deviceTargetKeys.map(id => parseInt(id)),
        emissionTargetKeys.map(id => parseInt(id))
      );
      message.success("Resources assigned successfully");
      onClose();
    } catch (err) {
      message.error("Failed to assign resources");
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={handleSave}
      title={`Assign ${initialTab === "devices" ? "Devices" : "Emission Points"} to ${user?.username}`}
      width={800}
      maskClosable={false}
    >
      <Transfer
        dataSource={initialTab === "devices" ? devices : emissionPoints}
        titles={["Available", "Assigned"]}
        targetKeys={initialTab === "devices" ? deviceTargetKeys : emissionTargetKeys}
        onChange={
          initialTab === "devices"
            ? setDeviceTargetKeys
            : setEmissionTargetKeys
        }
        render={item => item.title}
        listStyle={{ width: 340, height: 300 }}
      />
    </Modal>
  );
}